import { Button, Hero } from "../components/ui/index.ts";

export default function NotFound() {
  return (
    <Hero
      eyebrow="404"
      title="Not found."
      lede="No page here. This one has exactly zero solutions, which is one fewer than we promise."
      emblem="none"
      actions={<Button to="/">Back to the front</Button>}
    />
  );
}
